// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    PRODUCTION: false,
    NAME: 'qa',
    API_URL: 'https://z7q639lku1.execute-api.us-east-1.amazonaws.com/',
    HOST: 'z7q639lku1.execute-api.us-east-1.amazonaws.com',
    COOKIE_DOMAIN: '.truelearn.net',
    COOKIE_EXPIRY: 3600,
    CLASSIC_URL: 'https://admin-qa.truelearn.net',
    AUTH_URL: 'https://faculty-qa.truelearn.net',
    DEBUG_URL: 'https://faculty-qa.truelearn.net',
    DEBUG_LOCALLY: false, // NEVER CHANGE THIS VALUE
    SHOW_BANNER: true,
    LAUNCH_DARKLY_CLIENT_SIDE_ID: '5f205d23b5c3bc0a9dbf7327',
    LAUNCH_DARKLY_KEY: 'api-f2ac6f0d-1bc9-46e5-bdc1-d776c75c7f9e',
    URL_TO_MEMBER: 'https://member-legacy-qa.truelearn.net',
    AMCHARTS_KEY: 'AM5C307588084',
    AUTH_SERVER_URL: 'https://login-qa.truelearn.net',
    S3_BUCKET_URL: 'https://d2dwv5gubgo49b.cloudfront.net/',
    PICMONIC_ENTRYPOINT_URL: 'https://main.picmonic.com/login',
    LEARNER_BULK_IMPORT_FILE_NAME: 'upload_learners_example_qa',
    ADMIN_LEARNER_BULK_IMPORT_FILE_NAME: 'admin_upload_learners_example_qa',
    FACULTY_BULK_IMPORT_FILE_NAME: 'upload_faculty_example',
    ADMIN_FACULTY_BULK_IMPORT_FILE_NAME: 'admin_upload_faculty_example'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
